import { render, staticRenderFns } from "./AqTabs.vue?vue&type=template&id=62c2b804&scoped=true&"
import script from "./AqTabs.vue?vue&type=script&lang=js&"
export * from "./AqTabs.vue?vue&type=script&lang=js&"
import style0 from "./AqTabs.vue?vue&type=style&index=0&id=62c2b804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2b804",
  null
  
)

export default component.exports